<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="pa-0 ma-0" cols="12" sm="3">
        <v-text-field
          :autocomplete="autocompleteValueLocal"
          class="mr-3 to-upper"
          :label="$t('expired_depots.search')"
          autofocus
          prepend-icon="mdi-magnify"
          v-bind:clearable="true"
          clear-icon="mdi-close"
          v-model="search"
          :outlined="is_boxes"
          :dense="is_boxes"
          @input="
            debounceInput();
            updateLocalStorage();
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-data-table
        :footer-props="{
          'items-per-page-options': dataTableOptions,
        }"
        fixed-header
        :headers="headers"
        :options="options"
        :server-items-length="totalItems"
        :loading-text="this.$t('loading')"
        class="elevation-0"
        :height="'calc(-200px + 100vh)'"
        style="width: 100%"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items-per-page="itemsPerPage"
        item-key="identifier"
        @update:sort-by="updateSort"
        @update:sort-desc="updateSortOrder"
        @update:page="updatePagination"
        @update:items-per-page="updateItemsPerPage"
        :items="expiredDepots"
        :key="forceReloadComponentKey"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <span v-if="item?.vehicle?.registration_number">
                {{ item?.vehicle?.registration_number }}
              </span>
            </td>
            <td>
              <span v-if="item.client">
                {{ item.client.name }}
                {{ item.client.first_name ? item.client.first_name : "" }}</span
              >
            </td>
            <td>
              <span v-if="item.created_at"> {{ formatDate(item.created_at) }} </span>
            </td>
            <td>
              {{ formatDate(item.expiration_date) }}
              <span style="color: red" v-if="item.expired_ago > 0">
                <strong>({{ formatDays(item.expired_ago) }})</strong>
              </span>
            </td>
            <td>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="primary" @click="extendDepotPopUp(item)"
                    >mdi-home-plus</v-icon
                  >
                </template>
                {{ $t('nav_buttons.depot_extend') }}
              </v-tooltip> -->
              <v-menu bottom left :offset-y="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="extendDepotWithoutBillPopUp(item)">
                    <v-icon color="primary">mdi-home-plus</v-icon>
                    <v-list-item-title class="pl-2">{{
                      $t("expired_depots.depot_extend_without_bill")
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="extendDepotWithBillPopUp(item)">
                    <v-icon color="primary">mdi-file-document-plus</v-icon>
                    <v-list-item-title class="pl-2">{{
                      $t("expired_depots.depot_extend_with_bill")
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-row>
    <confirmation-model
      v-if="confirmationDialog"
      :showDialog.sync="confirmationDialog"
      :openedForOperation.sync="confirmationDialogOperation"
      :text.sync="confirmationDialogConfirmationText"
      :checkboxText.sync="confirmationDialogReCheckBoxConfirmationText"
      :trueText.sync="confirmationDialogTrueText"
      :falseText.sync="confirmationDialogFalseText"
      @buttonClicked="confirmationButtonClicked"
    ></confirmation-model>

    <v-btn
      @click="exportDataForExport"
      class="d-none"
      id="export-data"
    ></v-btn>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import _ from "lodash";
import { API_BASE_URL } from "@/config";
import { EXPIRED_DEPOT_LISTING_MODE } from "@/config";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";
import ConfirmationModel from "@/components/ConfirmationModel";
import moment from "moment";

export default {
  name: "ExpiredDepotListing",
  components: {
    "confirmation-model": ConfirmationModel,
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      expiredDepots: [],
      alerts: [],
      search: "",
      isLoading: true,
      totalItems: 0,
      lastPage: 1,
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      options: {},
      sortBy: "expiration_date",
      sortDesc: false,
      sortOrd: "ASC",
      sort: {},
      showAlert: false,
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      autocompleteValueLocal: "off",
      isDebounceCancelled: false,

      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogReCheckBoxConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,

      selectedDepot: null,
    };
  },
  async mounted() {
    this.$store.commit("setFormMode", EXPIRED_DEPOT_LISTING_MODE);
    this.confirmationDialog = false;
    this.confirmationDialogConfirmationText = null;
    this.confirmationDialogReCheckBoxConfirmationText = null;
    this.confirmationDialogFalseText = null;
    this.confirmationDialogTrueText = null;
    this.confirmationDialogButtonClickedIs = null;
    this.confirmationDialogOperation = null;

    this.header = { Authorization: "Bearer " + this.token };
    this.autocompleteValueLocal = this.autocompleteValue();
    this.headers.push({});
    this.headers.splice(-1);
    await this.applyPreviousFilters();
    this.fetchData();
  },
  methods: {
    exportDataForExport(){
      this.fetchData(null, true);
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    extendDepotWithBillPopUp(item) {
      this.selectedDepot = item;
      this.confirmationDialogConfirmationText = this.$t(
        "expired_depots.extend_confirmation"
      );
      this.confirmationDialogFalseText = this.$t("articles.cancel");
      this.confirmationDialogTrueText = this.$t("yes");
      this.confirmationDialogOperation = "extend_depot_with_bill";
      this.confirmationDialog = true;
    },
    extendDepotWithoutBillPopUp(item){
      this.selectedDepot = item;
      this.confirmationDialogConfirmationText = this.$t(
        "expired_depots.extend_confirmation"
      );
      this.confirmationDialogFalseText = this.$t("articles.cancel");
      this.confirmationDialogTrueText = this.$t("yes");
      this.confirmationDialogOperation = "extend_depot_without_bill";
      this.confirmationDialog = true;
    },
    extendDepot(depot) {
      axios
        .put(API_BASE_URL + "/depots/" + depot.id + "?extend_depot=1", {
          headers: this.header,
        })
        .then(() => {
          this.fetchData();
        })
        .catch(() => {
          this.$toast.success(
            this.$t("vehicle.something_went_wrong_while_fetching_data")
          );
        })
        .finally(() => {
          this.selectedDepot = null;
        });
    },
    extendDepotWithBill(depot) {
        this.$store.commit("setSelectedDepotForExtending", depot);
        if(this.checkTag('billing')){
            this.$router.push('/billing/add');
        }
        else if(this.checkTag('scheduler')){
            this.$router.push('/scheduler/add');
        }
    },
    debounceInput: _.debounce(function () {
      if (this.isDebounceCancelled) {
        this.isDebounceCancelled = false;
        return false;
      }
      this.fetchData();
    }, 500),
    updateLocalStorage() {
      let filters = {
        items_per_page: this.itemsPerPage,
        sortBy: this.sortBy,
        sortOrd: this.sortOrd,
        search: this.search ?? "",
      };
      localStorage.setItem(
        "EXPIRED_DEPOT_LISTING_FILTERS",
        JSON.stringify(filters)
      );
    },
    applyPreviousFilters() {
      return new Promise((resolve) => {
        let clientFilters = JSON.parse(
          localStorage.getItem("EXPIRED_DEPOT_LISTING_FILTERS")
        );

        if (clientFilters != null) {
          this.itemsPerPage = clientFilters.items_per_page;
          this.sortBy = clientFilters.sortBy;
          this.sortOrd = clientFilters.sortOrd;
          this.search = clientFilters.search;
        }
        return resolve();
      });
    },
    getLocalisationFromDepot(item) {
      let localisation = "";
      let activeDepot = 0;
      if (item.depot) {
        item.depot.forEach((element) => {
          if (element.status_id == 10171001 && element.deleted_at == null) {
            // depot stored
            activeDepot++;
            localisation += element.localisation
              ? " " + element.localisation + ","
              : "";
          }
        });
        if (activeDepot > 0 && !localisation.trim()) {
          return this.$t("yes");
        } else if (activeDepot > 0 && localisation.trim()) {
          return localisation.slice(0, -1);
        } else {
          return "";
        }
      }
    },
    fetchData(currentPage = null, is_export = false) {
      if (!currentPage) {
        this.options.page = 1;
        this.resetDataTable(currentPage);
      }

      this.isLoading = true;
      const payload = {
        page: this.page,
        items_per_page: this.itemsPerPage,
        order_by: this.sortBy,
        order_direction: this.sortOrd,
        search: this.search,
      };
      axios.get(API_BASE_URL + "/depots?expired=1&with_relationships=1" + (is_export ? '&is_export=1' : ''), { headers: this.header,  params: {
            ...payload,
        }}
        )
        .then((data) => {
            if (is_export) {
              let reportDataInRowsColumns = data.data;
              let CSVkeysOrHeaders = ['registration_number', 'full_name', 'entry_date', 'expiry_date'];
              reportDataInRowsColumns.forEach((element) => {
                console.log(element);
                element.registration_number = element?.vehicle?.registration_number;
                element.full_name = element?.client?.full_name;
                element.entry_date = element?.created_at;
                element.expiry_date = element?.expiration_date;
                return element;
              })
              let currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
              console.log("data", reportDataInRowsColumns);
              this.downloadCSVFromJson(
                "ExpiredDepot_" + currentDateTime + ".csv",
                CSVkeysOrHeaders,
                reportDataInRowsColumns
              );
            }
            else{
                this.expiredDepots = data.data.data;
                //   this.expiredDepots.forEach((vehicle) => {
                //     vehicle.is_leasing = vehicle.is_leasing == 1 ? true : false;
                //   });
                this.totalItems = data.data.meta.total;
                this.isLoading = false;
            }
        })
        .catch((error) => {
          console.log(error);
          this.$toast.success(
            this.$t("vehicle.something_went_wrong_while_fetching_data")
          );
        });
    },
    updatePagination(page) {
      this.page = page;
      this.fetchData(page);
    },
    updateItemsPerPage(itemsPerPage) {
      itemsPerPage == -1
        ? (this.itemsPerPage = this.totalItems)
        : (this.itemsPerPage = itemsPerPage);
      this.fetchData();
    },
    updateSort(sortBy) {
      if (typeof sortBy == "object") {
        this.sortBy = sortBy[0];
      } else {
        this.sortBy = sortBy;
      }
    },
    updateSortOrder(sortDesc) {
      if (typeof sortDesc == "object") {
        !sortDesc[0] ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      } else {
        !sortDesc ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("expired_depots.registration_number"),
          value: "registration_number",
          sortable: false,
        },
        {
          text: this.$t("expired_depots.client_name"),
          value: "client_name",
          sortable: false,
        },
        {
          text: this.$t("expired_depots.entry_date"),
          value: "entry_date",
          sortable: false,
        },
        {
          text: this.$t("expired_depots.expiry_date"),
          value: "expiration_date",
          sortable: true,
        },
        {
          text: this.$t("expired_depots.actions"),
          value: "actions",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal == true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation == "extend_depot_without_bill" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.extendDepot(this.selectedDepot);
        }
        if (
          this.confirmationDialogOperation == "extend_depot_with_bill" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.extendDepotWithBill(this.selectedDepot);
        }
        this.confirmationDialog = false;
        this.confirmationDialogButtonClickedIs = null;
      }
    },
    sortOrd: {
      handler: function () {
        this.fetchData();
      },
    },
    sortBy: {
      handler: function () {
        this.fetchData();
      },
    },
  },
};
</script>
<style scoped></style>
